import { render, staticRenderFns } from "./CustomerLoading.vue?vue&type=template&id=86e8956e&scoped=true&"
import script from "./CustomerLoading.vue?vue&type=script&lang=js&"
export * from "./CustomerLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e8956e",
  null
  
)

export default component.exports